import { ReactNode, memo } from 'react';
import Typography, { ITypographyProps } from '../Typography';
import Grid, { IGridProps } from '../Grid';
import Tooltip from '../Tooltip';
import HelpIcon from '../../icons/HelpIcon';
import { S5 } from '../../theme';

export interface ITypographyWithHelpProps {
  children: ReactNode;
  GridProps?: IGridProps;
  TypographyProps?: ITypographyProps;
  color?: string;
  helperText: string;
}

const TypographyWithHelp = (props: ITypographyWithHelpProps) => {
  const {
    children,
    GridProps,
    TypographyProps,
    color = S5,
    helperText,
  } = props;
  return (
    <Grid container item alignItems="center" flexWrap="nowrap" {...GridProps}>
      <Grid item>
        <Typography color={color} variant="subtitle1" pr={1} {...TypographyProps}>
          {children}
        </Typography>
      </Grid>
      <Grid item height={24}>
        <Tooltip title={helperText} cursorPointer>
          <HelpIcon color={color} />
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default memo(TypographyWithHelp);
